/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Create_TitleInputs */



/**
* | output |
* | --- |
* | "New promo" |
*
* @param {Promo_Create_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_create_title = /** @type {((inputs?: Promo_Create_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Create_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouvelle promo")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nueva promo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nova promo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuova promo")
	return /** @type {LocalizedString} */ ("New promo")
});